import type { AxiosRequestConfig } from 'axios'
import type { ITemplate, ITemplateParams } from '~/types/template'

import config from '~/config'
import { request } from '~/utils/request'

export const getTemplates = (params?: AxiosRequestConfig['params']): Promise<IPaginatedResponse<ITemplate>> => {
  return request({
    params,
    url: `${config.DYNAMIC_SCREEN_API}/templates`,
  })
}

export const getTemplate = ({ deviceType, isUnity, key, version }: ITemplateParams): Promise<ITemplate> => {
  return request({
    url: `${config.DYNAMIC_SCREEN_API}/templates/${key}/versions/${version}/device-type/${deviceType}/is-unity/${isUnity}`,
  })
}

export const activateTemplate = ({ deviceType, isUnity, key, version }: ITemplateParams): Promise<void> => {
  return request({
    method: 'PUT',
    url: `${config.DYNAMIC_SCREEN_API}/templates/${key}/versions/${version}/device-type/${deviceType}/is-unity/${isUnity}/activate`,
  })
}

export const getTemplateVersions = (key: string): Promise<IPaginatedResponse<ITemplate>> => {
  return request({
    url: `${config.DYNAMIC_SCREEN_API}/templates/${key}/versions`,
  })
}
